import { forwardRef } from 'react';
import { MantineLoaderComponent } from '@mantine/core';
import Lottie from 'lottie-react';
import aiLoaderOrange from 'src/UI/app-container/chat/assets/AI-loader-orange.json';

export const AfternoonLoader: MantineLoaderComponent = forwardRef(({ ...others }, ref) => (
  <Lottie
    style={{ height: '20px' }}
    animationData={aiLoaderOrange}
    loop={true}
    {...others}
    ref={ref}
  />
));
AfternoonLoader.displayName = 'Afternoon loader';
